import { createAction, props } from '@ngrx/store';
import { prop } from '@uirouter/angularjs';
import { Map as ImMap } from 'immutable';

import { DxFilterField, DxSortField } from '../../core/dx-types';
import { GroupingTagItemEntity } from '../domain/grouping-tag-item.entity';
import { ProjectsForGroupingTag } from '../domain/grouping-tag.types';

export enum GroupingTagActions {
	GetGroupingTagPage = '[Grouping Tag] fetch available grouping tag',
	GetGroupingTagPageSuccess = '[Grouping Tag] successfully retrieved available grouping tag',
	GetGroupingTagPageFailure = '[Grouping Tag] failure while retrieved available grouping tag',
	CreateGroupingTag = '[Grouping Tag] create grouping tag',
	CreateGroupingTagSuccess = '[Grouping Tag] successfully create grouping tag',
	CreateGroupingTagFailure = '[Grouping Tag] failure create grouping tag',
	UpdateGroupingTag = '[Grouping Tag] update grouping tag',
	UpdateGroupingTagSuccess = '[Grouping Tag] successfully update grouping tag',
	UpdateGroupingTagFailure = '[Grouping Tag] failure updating grouping tag',
	DeleteGroupingTag = '[Grouping Tag] delete grouping tag',
	DeleteGroupingTagSuccess = '[Grouping Tag] successfully deleted selected grouping tag(s)',
	DeleteGroupingTagFailure = '[Grouping Tag] failure while deleting grouping tags',
	FetchProjectCountByGroupingTag = '[Grouping Tag] fetch project count for grouping tags',
	FetchProjectCountByGroupingTagSuccess = '[Grouping Tag] successfully fetch project count for grouping tags',
	FetchProjectCountByGroupingTagFailure = '[Grouping Tag] failed fetch project count for grouping tags',
	FetchReferencedProjectsByGroupingTagId = '[Grouping Tag] fetch referenced project for grouping tag',
	FetchReferencedProjectsByGroupingTagIdSuccess = '[Grouping Tag] successfully fetched referenced project for grouping tag',
	FetchReferencedProjectsByGroupingTagIdFailure = '[Grouping Tag] failure while fetching referenced project for grouping tag',
}

export const getGroupingTagsPage = createAction(
	GroupingTagActions.GetGroupingTagPage,
	props<{
		size: number;
		page: number;
		search: string;
		filteredFields: Array<DxFilterField>;
		sortedFields: Array<DxSortField>;
	}>()
);

export const getGroupingTagsPageSuccess = createAction(
	GroupingTagActions.GetGroupingTagPageSuccess,
	props<{ groupingTags: ImMap<string, GroupingTagItemEntity>; total: number }>()
);

export const getGroupingTagPageFailure = createAction(
	GroupingTagActions.GetGroupingTagPageFailure,
	props<{ error: unknown }>()
);

export const createGroupingTag = createAction(
	GroupingTagActions.CreateGroupingTag,
	props<{
		label: string;
		color: string;
	}>()
);

export const createGroupingTagSuccess = createAction(
	GroupingTagActions.CreateGroupingTagSuccess
);

export const createGroupingTagFailure = createAction(
	GroupingTagActions.CreateGroupingTagFailure,
	props<{ error: unknown }>()
);

export const updateGroupingTag = createAction(
	GroupingTagActions.UpdateGroupingTag,
	props<{
		id: string;
		label: string;
		color: string;
	}>()
);

export const updateGroupingTagSuccess = createAction(
	GroupingTagActions.UpdateGroupingTagSuccess
);

export const updateGroupingTagFailure = createAction(
	GroupingTagActions.UpdateGroupingTagFailure,
	props<{ error: unknown }>()
);

export const deleteGroupingTag = createAction(
	GroupingTagActions.DeleteGroupingTag,
	props<{
		selected: Array<string>;
	}>()
);

export const deleteGroupingTagSuccess = createAction(
	GroupingTagActions.DeleteGroupingTagSuccess
);

export const deleteGroupingTagFailure = createAction(
	GroupingTagActions.DeleteGroupingTagFailure,
	props<{ error: unknown }>()
);

export const fetchProjectCountByGroupingTag = createAction(
	GroupingTagActions.FetchProjectCountByGroupingTag,
	props<{
		ids: Array<string>;
	}>()
);

export const fetchProjectCountByGroupingTagSuccess = createAction(
	GroupingTagActions.FetchProjectCountByGroupingTagSuccess,
	props<{ targets: Array<{ id: string; count: number }> }>()
);

export const fetchProjectCountByGroupingTagFailure = createAction(
	GroupingTagActions.FetchProjectCountByGroupingTagFailure,
	props<{ error: unknown }>()
);

export const fetchReferencedProjectsByGroupingTagId = createAction(
	GroupingTagActions.FetchReferencedProjectsByGroupingTagId,
	props<{ id: string }>()
);

export const fetchReferencedProjectsByGroupingTagIdSuccess = createAction(
	GroupingTagActions.FetchReferencedProjectsByGroupingTagIdSuccess,
	props<ProjectsForGroupingTag>()
);

export const fetchReferencedProjectsByGroupingTagIdFailure = createAction(
	GroupingTagActions.FetchReferencedProjectsByGroupingTagIdFailure,
	props<{
		error: unknown;
	}>()
);
